import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    position:fixed;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(230,230,230, 0.5);
    z-index: 2;   
    .btn-yes{
        background-color: rgba(0, 149, 39, 0.8);
        
        :hover {
            transform: scale(1.2);
            color: #000;
            background-color: rgba(0, 149, 39, 1);

        }
    } 
`;

export const Container = styled.div`
    width: 95%;
    max-width: 500px;
    height: fit-content;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    margin-top: 80px;
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    padding: 5px 0;
    background-color:var(--morienGreen);

`;

export const Title = styled.div`
    flex: 1;
    padding-left: 15px;
    font-size: 1.1rem;
    font-weight: bold;
    color: white;
`;

export const Body = styled.div`
    padding-top:8px;
    overflow-x: scroll;
    p {
        padding: 0;
        margin: 0;
    }
`;


export const Button = styled.button`
    padding: 5px 15px;
    border: 0;
    font-size: 0.9rem;
    appearance: button;
    -webkit-appearance: button;
    background-color: #808080;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    :active{
        background-color: red;
    }
`

export const BtnClose = styled.button`
padding-right: 12px;
cursor: pointer;
border: none;
outline: none;
background: none;
font-size: 18px;
font-weight: bold;
:active {
    background-color: green;
    color: red;
}
`;